<template>
  <Layout>
    <div
      style="text-align: center; justify-content: center; margin: -14px -14px 0"
    >
      <div
        class="base-class"
        style="text-align: center; justify-content: center"
      >
        <div style="background-color: white; width: 100%; text-align: left">
          <div style="display: flex">
            <el-button class="creat-button">{{ activeName }} </el-button>
            <el-button class="creat-clear-button" @click="creatClearClick()">
              <div style="display: flex; height: 100%; align-items: center">
                <p style="font-size: 30px; margin-top: -3px">+</p>
                <p style="margin-left: 5px">创建{{ btnName }}</p>
              </div>
            </el-button>
            <div class="search-item">
              <div>
                <i
                  class="el-icon-search"
                  style="
                    font-size: 20px;
                    margin-left: 18px;
                    margin-top: 10px;
                    color: #8e89aa;
                  "
                ></i>
              </div>

              <el-input
                placeholder="输入搜索关键词"
                v-model="filterName"
                class="input-with-search"
                clearable
                @keyup.enter.native="searchClick"
              >
              </el-input>

              <el-button
                icon="el-icon-search"
                class="search-button"
                @click="searchClick()"
              ></el-button>
            </div>
          </div>

          <div
            class="base-class"
            style="margin-top: 10px; margin-bottom: 0px; margin-left: 30px"
          >
            <el-tabs v-model="activeName">
              <el-tab-pane
                v-for="item in mstencilArray"
                :key="item.classifyName"
                :label="item.classifyName"
                :name="item.classifyName"
              ></el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>

      <div
        class="base-class"
        style="display: block; margin-top: 10px; min-height: 400px"
      >
        <div>
          <div style="display: flex; flex-wrap: wrap; margin-right: -10px">
            <div
              class="model-item"
              v-for="(item, index) in tableData"
              :key="index"
              @click="creatClick(2, item)"
            >
              <div style="display: flex">
                <el-image
                  class="click-image"
                  :src="imageUrl + item.cover_img"
                  style="
                    background-color: bisque;
                    margin: 11px;
                    border-radius: 3px;
                    margin-left: 0;
                  "
                ></el-image>

                <div style="width: 180px; max-width: 220px">
                  <p class="model-item-title">{{ item.name }}</p>
                  <p class="model-item-count">{{ item.auxiliarytitle }}</p>
                </div>
              </div>

              <i class="el-icon-arrow-right"></i>
              <!--              <div class="free-button" @click="creatClick(2,item)">免费使用</div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="el-pagination-wrap">
        <el-pagination
          background
          layout="sizes,total,prev, pager, next"
          :page-sizes="[20, 50, 100, 200]"
          :total="tablePage.total"
          :current-page="tablePage.pageNum"
          :page-size="tablePage.pageSize"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
      <el-dialog
        title="选择打卡类型"
        :visible.sync="frequencyPopShow"
        width="500px"
      >
        <div>
          <div class="f-list-box">
            <div class="f-inner">
              <div
                class="f-item"
                v-for="(item, index) in frequencyOptionList"
                :class="{ freBgColor: item.isClick == true }"
                :key="index"
                @click="toPageBuild(item.frequencyType, index)"
              >
                <div class="bigTitle">{{ item.bigTitle }}</div>
                <div class="tips">{{ item.tips }}</div>
                <div class="a-right"><i class="el-icon-arrow-right"></i></div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { getHomePageTempleList } from "@/utils/api/activity";
import { imageUrl } from "@/utils/config/commonUrl.js";
import copyrightConfig from "@/utils/config/changeCopyright.js";

// import { getUserInfo } from "@/utils/api/user";
/**
 * Basic-table component
 */
export default {
  page(){
    const title = this.activeName + " - 发布接龙 - 接龙模版" || "发布接龙 - 接龙模版";
    return {
      title: title,
      meta: [{ name: "description", content: appConfig.description }],
    };
  },
  components: { Layout },
  data() {
    return {
      imageUrl: imageUrl,
      filterName: "",
      activeName: "全部模版",
      mstencilArray: [],

      templateIndex: 3,
      classifyName: "",
      classifyNameCopy: "",
      tableData: [],

      tablePage: {
        pageNum: 1, //
        pageSize: 50,
        total: 0,
      },
      searchText: "",
      routeParameter: {},
      isType: "",
      btnName: "",
      signInfoPop: false,
      frequencyPopShow: false,
      frequencyOptionList: [
        {
          bigTitle: "一次性打卡",
          tips: "只需要一次打卡，不需要反复打卡",
          frequencyType: 8,
          isShow: true,
          isClick: false,
        },
        {
          bigTitle: "按天打卡",
          tips: "每人每天打卡x次",
          frequencyType: 3,
          isShow: true,
          isClick: false,
        },
        {
          bigTitle: "按周打卡",
          tips: "每人每周打卡x次",
          frequencyType: 2,
          isShow: true,
          isClick: false,
        },
        {
          bigTitle: "按月打卡",
          tips: "每人每月打卡x次",
          frequencyType: 1,
          isShow: true,
          isClick: false,
        },
        {
          bigTitle: "法定工作日",
          tips: "只再法定工作日打卡x次，节假日不打卡",
          frequencyType: 4,
          isShow: true,
          isClick: false,
        },
        {
          bigTitle: "法定节假日",
          tips: "只再法定节假日打卡x次，工作日不打卡",
          frequencyType: 5,
          isShow: true,
          isClick: false,
        },
        {
          bigTitle: "自定义周几打卡",
          tips: "一周内可自定义星期几打卡x次，其他时间不打卡",
          frequencyType: 6,
          isShow: true,
          isClick: false,
        },
        {
          bigTitle: "自定义日期打卡",
          tips: "适合打卡日期不规律的场景",
          frequencyType: 7,
          isShow: true,
          isClick: false,
        },
      ],
      selectFrequency: "3", // 频率类型 1=每月｜2=每周｜3=每天｜4=法定工作日｜5=法定节假日｜6=自定义周几打卡｜7=自定义日期打卡 | 8=一次性打卡
      commentTitle: "",
    };
  },
  created() {
    this.routeParameter = this.$route.query;
    this.isType = this.routeParameter.isType;
    if (this.isType == 106) {
      this.btnName = copyrightConfig.AppID == "wx7d8daf6d777947a2" ? "通用报名" : "通用接龙";
    }
    if (this.isType == 104) {
      this.btnName = "签到接龙";
    }
    if (this.isType == 109) {
      this.btnName = "打卡接龙";
    }
    if (this.isType == 201) {
      this.btnName = "通知公告";
    }
    if (!localStorage.getItem("token")) {
      this.$router.replace("/login");
    }

    console.log(this.$route.query, "templateIndex");
    if (this.$route.query.templateIndex) {
      this.templateIndex = this.$route.query.templateIndex;
      if (this.templateIndex == "1") {
        this.classifyName = this.$route.query.classifyName;
        this.classifyNameCopy = this.$route.query.classifyName;
        if (this.classifyName == "打卡") {
          this.classifyName = "";
          this.searchText = "打卡";
        }
        if (this.classifyName == "签到") {
          this.classifyName = "";
          this.searchText = "签到";
        }
      }
      this.getList(this.templateIndex);
    }

    console.log(this.classifyName, "this.classifyName ");
    if (this.classifyName != "") {
      this.activeName = this.classifyName;
      this.mstencilArray.push({
        classifyName: this.classifyName,
      });
    } else if (this.classifyNameCopy != "") {
      this.activeName = this.classifyNameCopy;
      this.mstencilArray.push({
        classifyName: this.classifyNameCopy,
      });
    }else if (this.templateIndex == "3") {
      this.activeName = copyrightConfig.AppID == "wx7d8daf6d777947a2" ? "通用报名" : "通用接龙";
      this.mstencilArray.push({
        classifyName: "通用接龙",
      });
    } else if (this.templateIndex == "4") {
      this.activeName = "签到打卡";
      this.mstencilArray.push({
        classifyName: "签到打卡",
      });
    } else if (this.templateIndex == "5") {
      this.activeName = "通知公告";
      this.mstencilArray.push({
        classifyName: "通知公告",
      });
    }
    console.log(this.mstencilArray, "this.mstencilArray");
  },
  mounted() {
    // 确保标题设置生效
    this.$nextTick(() => {
      this.setPageTitle();
    });
  },
  methods: {
    // 设置页面标题
    setPageTitle() {
      // 根据 AppID 确定后缀
      let suffix = '接龙加加';
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        suffix = '报名管家';
      }

      document.title = `接龙模版 - ${suffix}`;
      console.log(document.title, "document.title");
    },
    handleSizeChange(pageSize) {
      this.tablePage.pageNum = 1;
      this.tablePage.pageSize = pageSize;
      this.getList(this.templateIndex);
    },
    handlePageChange(currentPage) {
      this.tablePage.pageNum = currentPage;
      this.getList(this.templateIndex);
    },
    //搜索方法
    searchClick() {
      this.getList(this.templateIndex);
    },

    getList(templateIndex) {
      //获取列表数据
      getHomePageTempleList({
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.pageNum,
        templateIndex: templateIndex,
        filterName: this.filterName,
        classifyName: this.classifyName,
        name: this.searchText,
      }).then((res) => {
        console.log(res, "请求列表数据");
        if (res.status == 1) {
          this.tableData = res.data.list;
          this.tablePage.total = res.data.total;
        }
      });
    },

    // 创建空白接龙
    creatClearClick() {
      console.log("创建空白接龙");
      if (this.isType == 109 || this.isType == 104) {
        // this.$router.push({
        //     path: "/solitaire",
        //     query: { activityId: 2, selectType: "add", isType: 109},
        // });
        this.frequencyPopShow = true;
      }
      if (this.isType == 110) {
        this.$router.push({
          path: "/solitaire",
          query: { alias: "KBWJZBM4", selectType: "add", isType: 110 },
        });
      }
      if (this.isType == 106) {
        this.$router.push({
          path: "/solitaire",
          query: { alias: "KBWJZBM4", selectType: "add", isType: 106 },
        });
      }
      if (this.isType == 201) {
        this.$router.push({
          path: "/groupNotification",
          query: { alias: "I2V4ZJR5", isType: 201 },
        });
      }
    },

    // 创建自定义接龙
    creatClick(type, item) {
      console.log(type, item, "item");
      if (type == 1) {
        if (this.isType == 109) {
          this.$router.push({
            path: "/solitaire",
            query: { alias: "KBWJZBM4", selectType: "add", isType: 109 },
          });
        }
        if (this.isType == 110) {
          this.$router.push({
            path: "/solitaire",
            query: { alias: "KBWJZBM4", selectType: "add", isType: 110 },
          });
        }
        if (this.isType == 106) {
          this.$router.push({
            path: "/solitaire",
            query: { alias: "KBWJZBM4", selectType: "add", isType: 106 },
          });
        }
        if (this.isType == 201) {
          this.$router.push({
            path: "/groupNotification",
            query: { alias: "I2V4ZJR5", isType: 201 },
          });
        }
      } else {
        if (this.isType == 109) {
          this.$router.push({
            path: "/solitaire",
            query: { alias: item.activity_key, selectType: "add", isType: 109 },
          });
        }
        if (this.isType == 110) {
          this.$router.push({
            path: "/solitaire",
            query: { alias: item.activity_key, selectType: "add", isType: 110 },
          });
        }
        if (this.isType == 106) {
          this.$router.push({
            path: "/solitaire",
            query: { alias: item.activity_key, selectType: "add", isType: 106 },
          });
        }

        // 通知
        console.log("201啊");
        if (this.isType == 201) {
          this.$router.push({
            path: "/groupNotification",
            query: { alias: item.activity_key, selectType: "add", isType: 201 },
          });
        }
      }
    },
    // 去创建页
    toPageBuild(type, index) {
      this.frequencyPopShow = false;
      this.$router.push({
        path: "/solitaire",
        query: {
          activityId: 2,
          selectType: "add",
          isType: this.isType,
          rateType: type,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.base-class {
  display: flex;
  // min-width: 1100px;
}

.top-item {
  width: 397px;
  height: 120px;
  margin-right: 15px;
}

.top-image {
  width: 397px;
  height: 120px;
  position: absolute;
  z-index: -1;
}

.top-title {
  color: #ffffff;
  line-height: 33px;
  font-size: 24px;
  font-weight: 400;
  margin-left: 31px;
  margin-top: 18px;
  margin-bottom: 5px;
}

.top-count {
  color: #ffffff;
  line-height: 22px;
  font-size: 15px;
  font-weight: 200;
  margin-bottom: 13px;
}

.creat-text {
  color: #ffffff;
  line-height: 22px;
  text-align: right;
  font-size: 14px;
  margin-right: 10px;
}

.click-item {
  width: 235px;
  height: 93px;
  margin-right: 12px;
  background-color: #ffffff;
  margin-top: 10px;
  border-radius: 3px;
  display: flex;
}

.click-image {
  width: 66px;
  height: 66px;
  margin-top: 13px;
  margin-left: 22px;
}

.click-title {
  font-size: 19px;
  color: #2b2f36;
  line-height: 28px;
  margin-top: 21px;
  margin-bottom: 12px;
  margin-right: 5px;
}

.click-creat {
  color: #a2a2a2;
  line-height: 20px;
  font-size: 13px;
}

.model-top {
  justify-content: space-between;
  display: flex;
  width: 1220px;
  margin-top: 20px;
}

.model-top-title {
  color: #2b2f36;
  line-height: 21px;
  font-size: 16px;
  font-weight: 500;
}

.model-top-more {
  color: #686868;
  line-height: 19px;
  font-size: 14px;
}

.model-item {
  width: calc(20% - 10px); /* 动态计算宽度，减去间距 */
  height: 80px;
  //min-width: 345px;
  background-color: #ffffff;
  border-radius: 4px;
  display: flex;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  align-items: center;
  padding: 0 10px;
  justify-content: space-between;

  &:hover .model-item-title {
    color: #1877ff; /* 鼠标悬浮时的字体颜色 */
  }
}

.model-item-title {
  color: #333;
  line-height: 22px;
  font-size: 14px;
  margin-top: 18px;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
  text-align: left;
}

.model-item-count {
  color: #676767;
  line-height: 20px;
  font-size: 14px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.free-button {
  cursor: pointer;
  width: 80px;
  height: 31px;
  background-color: white;
  border-radius: 18px;
  border: solid 1px #1877ff;
  text-align: center;
  line-height: 31px;
  color: #1877ff;
  font-size: 13px;
  margin-top: 30px;
  margin-left: 10px;
}

::v-deep .el-tabs__nav-wrap::after {
  position: static !important;
}

::v-deep .el-tabs__item {
  color: #3f3f3f;
  font-weight: 400;
}

::v-deep .el-tabs__item.is-active {
  color: #1877ff;
  font-weight: 500;
}

::v-deep .el-tabs__item:hover {
  color: #1877ff;
}

::v-deep .el-tabs__active-bar {
  // width: 80px;
  height: 3px;
  border-radius: 4px;
}

::v-deep .el-tabs__active-bar.is-top {
  padding: 0 8px;
  border-radius: 4px;
  box-sizing: border-box !important;
  background-clip: content-box !important;
}

.sub-tab-item {
  text-align: center;
  background-color: #eeeeee;
  color: #909090;
  margin-right: 10px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 15px;
  height: 30px;
  line-height: 30px;
  font-size: 11px;
  cursor: pointer;
}

// #1877ff
.creat-button {
  width: 157px;
  margin-left: 20px;
  margin-top: 15px;
  background-color: white;
  font-size: 15px;
  color: #1877ff;
  border-radius: 6px;
  border: solid 1px #1877ff;
  text-align: center;
  height: 40px;
  p {
    margin-bottom: 0;
  }
}

.creat-clear-button {
  margin-left: 20px;
  margin-top: 15px;
  background-color: #1877ff;
  font-size: 15px;
  color: white;
  border-radius: 6px;
  border: solid 1px #1877ff;
  text-align: center;
  height: 40px;
  p {
    margin-bottom: 0;
  }
}

.search-item {
  margin-left: 20px;
  margin-top: 15px;
  background-color: #f8f8f8;
  width: 600px;
  height: 40px;
  overflow: hidden;
  border-radius: 20px;
  display: flex;
}

.search-button {
  width: 64px;
  height: 40px;
  background-color: #1877ff;
  font-size: 25px;
  color: white;
  border-radius: 30px;
  text-align: center;
  line-height: 25px;
  padding-top: 7px;
  // margin-top: 5px;
}

.input-with-search {
  margin-left: 5px;
  // margin-top: 5px;
  width: 495px;
}

.input-with-search {
  :deep(.el-input__inner) {
    border: 0px solid #dcdfe6;
    background-color: #f8f8f8;
  }
}

.f-list-box {
  padding: 15px 15px;
  box-sizing: border-box;
  background-color: #f8f8f8;
}

.f-title {
  color: #666;
  margin-bottom: 15px;
  text-align: center;
}

.f-inner {
  background-color: white;
  border-radius: 10px;
  /*width: 94%;*/
  margin: 0 auto;
  /*padding: 0 13px;*/
}

.f-item {
  padding: 10px 13px;
  border-bottom: 1px solid #eee;
  position: relative;
  cursor: pointer;

  .bigTitle {
    color: black;
    margin-bottom: 5px;
    text-align: left;
    font-weight: bold;
  }

  .tips {
    font-size: 11px;
    color: grey;
    text-align: left;
  }
}

.f-item:hover {
  background-color: #f4f4f4;
}

.a-right {
  position: absolute;
  right: 0px;
  top: 22px;
}

// .el-textarea__inner

// el-input__inner

//选中 #B8D5FF   #1877FF

.el-pagination-wrap {
  display: flex;
  justify-content: flex-end;
}
</style>
